import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CollapsibleDiv from 'react-collapse';
import { useTranslation } from 'react-i18next';
import isNull from 'lodash/isNull';
import classNames from 'classnames';
import SwitchableOdds from '~spa/Components/SwitchableOdds';
import BetCardSimple from '~spa/Components/BetCardSimple';
import BetButton from '~spa/Components/BetButton';
import { calculateAmericanPrice } from '~shared/components/sport-event/utils';
import { getPriceOdds } from '~shared/components/sport-event/utils';

import './betcard.scss';

const BetCardMulti = ({
    selections,
    betcard,
    cssClass,
    isOddsLimited = false,
}) => {
    const [ t ]= useTranslation();
    const [isExpanded, setIsExpanded] = useState(false);
    const {sportSlug = 'trophy'} = selections?.[0] || {};
    const shouldShowSportIcon = selections.every(selection => selection.sportSlug === sportSlug);
    const iconsSlug = shouldShowSportIcon ? sportSlug : 'trophy';

    const accumulatedSelection = selections.reduce((acc, selection, index) => {
        const {
            selectionId,
            decimalPrice,
            betable: selBetable,
            spOnly: selSpOnly,
            active: selActive,
            tradable: selTradable,
        } = selection;

        if (!index) {
            return {
                selection_id: selectionId,
                decimal_price: decimalPrice,
                fraction_price: decimalPrice,
                american_price: calculateAmericanPrice(decimalPrice),
                active: selActive,
                tradable: selTradable,
                betable: selBetable,
                sp_only: selSpOnly,
                sport_slug: sportSlug,
                gtmAttribute: 'betfeed;multiple;',
            };
        }

        const accPrice = (isNull(acc.decimal_price)) ? acc.decimal_price : Number(acc.decimal_price) * Number(decimalPrice);
        const betable = acc.betable && selBetable;
        const spOnly = acc.sp_only && selSpOnly;
        const active = acc.active && selActive;
        const tradable = acc.tradable && selTradable;
        const accDecimalPrice = getPriceOdds(accPrice, 'DECIMAL');

        return {
            selection_id: `${acc.selection_id}_${selectionId}`,
            decimal_price: accDecimalPrice,
            fraction_price: getPriceOdds(accPrice, 'FRACTION'),
            american_price: getPriceOdds(accPrice, 'AMERICAN'),
            active,
            tradable,
            betable,
            sp_only: spOnly,
            sport_slug: sportSlug,
            gtmAttribute: 'betfeed;multiple;',
            limitOddsDisplay: accDecimalPrice > 999 && isOddsLimited,
        };

    }, {});

    return (
        <div>
            <div className={`simple-betcard ${cssClass}`}>
                <div className='simple-betcard__selection'>
                    <div className='simple-betcard__selection__icon'>
                        <div className={`bb-icon bb-icon--size-24x24 bb-icon--${iconsSlug}`} />
                    </div>
                    <div>
                        <div>{
                            selections.map((selection, index) => {
                                const {
                                    selectionName,
                                    selectionId,
                                    sportSlug,
                                    spOnly,
                                    active,
                                    tradable,
                                    decimalPrice,
                                    fractionPrice,
                                    americanPrice,
                                } = selection;

                                const selectionForOdds = {
                                    sport_slug: sportSlug,
                                    sp_only: spOnly,
                                    active,
                                    tradable,
                                    decimal_price: decimalPrice,
                                    fraction_price: fractionPrice,
                                    american_price: americanPrice,
                                };

                                return <React.Fragment key={`selection-${selectionId}`}>
                                    <span>
                                        <span className='simple-betcard__selection-name'>{selectionName}</span>
                                        <span className='simple-betcard__odds'>
                                            <SwitchableOdds selection={selectionForOdds} />
                                        </span>
                                    </span>
                                    {index < selections.length - 1
                                    ? <span className='simple-betcard__selection-name'>, </span>
                                    : null}
                                </React.Fragment>;
                            })
                        }</div>
                        <div className="simple-betcard__multi-bet-type">
                            {t('betcard.selections', {count: selections.length, bet_type: betcard.bet_type})}
                        </div>
                    </div>
                </div>
                <BetButton {...accumulatedSelection} isMulti />
            </div>

            <div
                className='simple-betcard__dropdown-icon'
                onClick={() => setIsExpanded(!isExpanded)}
            >
                <div
                    className={classNames(
                        'bb-icon',
                        'bb-icon--expand-arrow',
                        'bb-icon--width-12',
                        {
                            'bb-icon--rotate-180': isExpanded,
                        }
                    )}
                ></div>
            </div>
            <CollapsibleDiv
                isOpened={isExpanded}
                className="multi-betcard__details"
            >

            {
                selections.map((selection) => {

                    return <BetCardSimple
                        key={`${betcard.betcard_id}-${selection.selectionId}`}
                        {...selection}
                        cssClass="simple-betcard--no-margin simple-betcard__multi-list"
                        noBetButton
                        isOddsLimited={isOddsLimited}
                    />;
                })
            }
            </CollapsibleDiv>
        </div>
    );
};

BetCardMulti.propTypes = {
    selections: PropTypes.array,
    betcard: PropTypes.object,
    cssClass: PropTypes.string,
    isOddsLimited: PropTypes.bool,
};

export default BetCardMulti;
